export default __webpack_public_path__ + "media/images/images/pages/fitness-profile-efe0184ab07c93c78f1c61de55780a89.jpg";